import Feature26 from './Feature26'
export default Feature26
